module.exports = __webpack_public_path__ + "img/fusion5-thumb.efab5faf.jpg";